// extracted by mini-css-extract-plugin
export var brand = "_1r-9";
export var button = "_1r-0";
export var chevron = "_1r-v";
export var chevronButton = "_1r-w";
export var content = "_1r-n";
export var danger = "_1r-g";
export var dangerOutlined = "_1r-h";
export var dark = "_1r-l";
export var darkTheme = "_1r-c";
export var extraSmall = "_1r-4";
export var fullWidth = "_1r-8";
export var ghost = "_1r-d";
export var gray = "_1r-t";
export var icon = "_1r-p";
export var iconButton = "_1r-s";
export var iconButtonBorder = "_1r-x";
export var iconButtonBorderDark = "_1r-y";
export var iconButtonBorderLight = "_1r-z";
export var iconLeft = "_1r-q";
export var iconRight = "_1r-r";
export var large = "_1r-1";
export var light = "_1r-m";
export var medium = "_1r-2";
export var micro = "_1r-5";
export var nano = "_1r-7";
export var outlined = "_1r-k";
export var pending = "_1r-a";
export var primary = "_1r-i";
export var shadow = "_1r-o";
export var small = "_1r-3";
export var solidLight = "_1r-e";
export var solidLightBrand = "_1r-f";
export var spinner = "_1r-u";
export var transparent = "_1r-j";
export var warning = "_1r-b";
export var wideNano = "_1r-6";